// app/javascript/controllers/products_hw_parts_form_controller.js
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = [
    "producibleType",
    "producibleTypeHidden",
    "producibleSearch",
    "producibleId",
    "autocompleteContainer",
    "container",
    "hwPartRow",
    "destroyField"
  ]

  connect() {
    this.index = this.hwPartRowTargets.length;
    // Listen for autocomplete changes
    document.addEventListener("autocomplete.change", this.handleAutocompleteChange.bind(this));
  }

  disconnect() {
    document.removeEventListener("autocomplete.change", this.handleAutocompleteChange.bind(this));
  }

  handleAutocompleteChange(event) {
    // Autocomplete controller už nastavil hidden field value
    // Můžeš zde přidat další logiku pokud potřebuješ
  }

  handleProducibleInput(event) {
    // Clear hidden field when user types
    if (this.producibleIdTarget.value) {
      this.producibleIdTarget.value = '';
    }
  }

  producibleTypeChanged(event) {
    const newType = event.target.value;
    this.producibleTypeHiddenTarget.value = newType;
    this.producibleSearchTarget.value = '';
    this.producibleIdTarget.value = '';

    // Update autocomplete URL based on type
    const autocompleteController = this.application.getControllerForElementAndIdentifier(
      this.autocompleteContainerTarget,
      'autocomplete'
    );

    if (autocompleteController) {
      const newUrl = newType === 'Product'
        ? '/products/search?without_prices=true&include_placeable=true'
        : '/hw_parts/search';

      autocompleteController.element.dataset.autocompleteUrl = newUrl;
    }
  }

  addHwPart(event) {
    event.preventDefault();

    const template = this.hwPartRowTargets[0].cloneNode(true);
    const newIndex = this.index++;
    template.innerHTML = template.innerHTML.replace(/\[0\]/g, `[${newIndex}]`);

    template.querySelectorAll('input, select').forEach(input => {
      if (input.type === 'hidden' && input.name.includes('[id]')) {
        input.value = '';
      } else if (input.type === 'number') {
        input.value = input.name.includes('amount') ? '1' : '0';
      } else if (input.tagName === 'SELECT') {
        input.selectedIndex = 0;
      }
    });

    this.containerTarget.appendChild(template);
  }

  removeHwPart(event) {
    event.preventDefault();

    const row = event.target.closest('[data-target="products-hw-parts-form.hwPartRow"]');
    const destroyField = row.querySelector('[data-target="products-hw-parts-form.destroyField"]');

    if (destroyField && row.querySelector('input[name*="[id]"]')?.value) {
      destroyField.value = '1';
      row.style.display = 'none';
    } else {
      row.remove();
    }
  }
}
